export default "__VITE_ASSET__CDCbmGRH__"